import { DirectiveOptions } from 'vue';

const numberField: DirectiveOptions = {
    bind(el, binding, vnode) {
        checkNumber(el, binding);
    },
};

const checkNumber = (el: any, binding: any) => {
    if ( binding.value.number ) {
        el.addEventListener('keydown', (e: any) => {
            const isNumber = checkNumberValue(el, e);
            if ( isNumber ) {
                const valid = checkMaxValue(binding, el, e);
                if (valid) {
                    return;
                } else {
                    e.preventDefault();
                }
            } else {
                e.preventDefault();
            }
        });
    }
};

const checkNumberValue = (el: any, e: any) => {
    if ( checkKeyPressNumber(e) ) {
        if ( e.keyCode === keyCodeList.dot ) {
            const oldValue = el.value;
            const newChar = getCharFromKeyCode(e.keyCode);
            const newValue = oldValue + newChar;
            const newValueNumber = Number(newValue) ;
            if (
                checkLastChar(e.keyCode, oldValue) &&
                !isNaN(newValueNumber)
            ) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    }
    return false;
};

const checkKeyPressNumber = (e: any) => {
    if (
        checkKeyCodePermitted(e) ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && e.ctrlKey === true) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && e.ctrlKey === true) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        // let it happen, don't do anything
        return true;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        return false;
    }
    return true;
};

const checkMaxValue = (binding: any, el: any, e: any) => {
    let maxValue = binding.value.max;
    if ( maxValue !== '') {
        maxValue = Number(maxValue);
        const oldValue = el.value;
        const newChar = getCharFromKeyCode(e.keyCode);
        const newValue = oldValue + newChar;
        const newValueNumber = Number(newValue) ;

        if (
            (
                checkLastChar(e.keyCode, oldValue) &&
                !isNaN(newValueNumber) &&
                maxValue >= newValueNumber
            ) ||
            checkKeyCodePermitted(e) &&
            checkLastChar(e.keyCode, oldValue)

        ) {
            return true;
        } else {
            return false;
        }
    }
    return true;
};

const keyCodeList =  {
    backSpace: 8,
    tab: 9,
    enter: 13,
    escape: 27,
    leftArrow: 37,
    rightArrow: 39,
    deleteKey: 46,
    decimalPoint: 110,
    comma: 188,
    dot: 190,
};

const checkKeyCodePermitted = (e: any) => {
    return [
        keyCodeList.deleteKey,
        keyCodeList.backSpace,
        keyCodeList.tab,
        keyCodeList.escape,
        keyCodeList.enter,
        keyCodeList.decimalPoint,
        keyCodeList.dot,
        keyCodeList.rightArrow,
        keyCodeList.leftArrow,
    ].indexOf(e.keyCode) !== -1;
};

const checkLastChar = (keyCode: string, value: string) => {
    return (
        value !== undefined &&
        value[value.length - 1] !== '.' ||
        (
            value[value.length - 1] === '.' &&
            keyCode !== keyCodeList.dot.toString()
        )
    );
};

const getCharFromKeyCode = (keyCode: number) => {
    let char = String.fromCharCode(keyCode);
    if ( keyCode === keyCodeList.dot ) {
        char = '.';
    }
    return char;
};

export default numberField;
